"use client";

import { GitCompareArrows } from "lucide-react";
import { useCompareStore } from "@/store/compare.store";
import { cn } from "@/lib/utils";
import { useHasHydrated } from "@/hooks/use-has-hydrated";

interface CompareProduct {
  id: string;
  name: string;
  slug: string;
  price: number;
  coverImageUrl?: string;
  categoryName?: string;
}

interface CompareButtonProps {
  product: CompareProduct;
  size?: "sm" | "md";
  className?: string;
}

export function CompareButton({ product, size = "md", className }: CompareButtonProps) {
  const hasHydrated = useHasHydrated();
  const { toggle, has, items } = useCompareStore();
  // Hydration tamamlanana kadar SSR ile aynı değeri göster, client hydration sonrası gerçek değer
  const isSelected = hasHydrated && has(product.id);
  const isFull = hasHydrated && items.length >= 4 && !isSelected;

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    toggle({
      id: product.id,
      name: product.name,
      slug: product.slug,
      price: product.price,
      coverImageUrl: product.coverImageUrl,
      categoryName: product.categoryName,
    });
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={isFull}
      aria-label={isSelected ? "Karşılaştırmadan çıkar" : "Karşılaştırmaya ekle"}
      title={isFull ? "En fazla 4 ürün karşılaştırabilirsiniz" : undefined}
      className={cn(
        "flex items-center justify-center rounded-full backdrop-blur-sm border transition-all hover:scale-110 shadow-sm disabled:opacity-40 disabled:cursor-not-allowed disabled:hover:scale-100",
        size === "sm" ? "w-8 h-8" : "w-11 h-11",
        isSelected
          ? "border-black bg-black text-white hover:border-black"
          : "border-gray-200 bg-white/90 text-gray-400 hover:border-gray-300 hover:text-gray-700",
        className
      )}
    >
      <GitCompareArrows
        className={cn("transition-colors", size === "sm" ? "w-3 h-3" : "w-4.5 h-4.5")}
        style={{ width: size === "sm" ? 12 : 18, height: size === "sm" ? 12 : 18 }}
      />
    </button>
  );
}
